









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import ProfileImage from '@/components/Media/ProfileImage.vue';

@Component({
    name: 'EventCardSocials',
    components: {
        ProfileImage,
    },
})
export default class EventCardSocials extends Vue {
    @Prop({ required: true }) public id: number;
    @Prop({ required: true }) public haveLike: boolean;
    @Prop({ default: 0 }) public likesCount: number;
    @Prop({ default: 0 }) public commentsCount: number;
    @Prop({ default: () => [] }) public likeRecipients: number[];

    constructor() {
        super();
    }

    get disabled(): boolean {
        return this.$store.getters['Likes/getLikeRequestIsActive'];
    }

    public like() {
        if (this.disabled) {
            return false;
        }

        const action = !this.haveLike ? Actions.ADD_LIKE : Actions.REMOVE_LIKE;
        this.$store.dispatch(action, { likeable: 'Notification', id: this.id});
    }

    public showComments() {
        this.$store.commit(Mutations.SET_COMMENTS_OVERLAY_VISIBILITY, true);

        this.$store.dispatch(Actions.FETCH_TENANT_NOTIFICATION, this.id).then(() => {
            this.$store.dispatch(Actions.FETCH_NOTIFICATION_COMMENTS, {vue: this, notificationId: this.id});
        });
    }
}
